import { Factory as SocketFactory } from "./Factory";
export var Socket;
(function (Socket) {
    Socket.Factory = SocketFactory;
})(Socket || (Socket = {}));
//# sourceMappingURL=index.js.map